import SliderController from '@app/Product/SliderController'
import InfoReceiver from '@app/Product/InfoReceiver'
import AmbassadorRecommends from '@app/Product/AmbassadorRecommends'

export default function install(Vue) {
  Vue.component('product-slider-controller', SliderController)
  Vue.component('product-info-receiver', InfoReceiver)
  Vue.component('product-ambassador-recommends', AmbassadorRecommends)
}
